import { retryLazyImport } from '@/helpers/retry-lazy-import.js';
import i18n from '@/plugins/i18n.js';

const MyCompanyPage = retryLazyImport(() => import('@/modules/company/MyCompanyPage.vue'));

export default [
  {
    path: '/company/:companyId',
    name: 'company.myCompany',
    component: MyCompanyPage,
    props: true,
    meta: {
      requiresAuth: true,
      featureFlag: 'enable-luna-company-info-page',
      title: () => i18n.global.t('routes.pageTitles.myCompany')
    }
  }
];
